import StateMachine from './state-machine';
import hdrm from '../../hdrm';
import { connectedStore } from '../../store';
import actions from '../actions';

const SELECTION_LISTENER_DELAY = 100;

const revertListListener = (ownerDocument, element, initListState) => {
  const listenerState = new StateMachine({
    keydownListenerId: null,
    selectionChangeListenerId: null,
  });

  const removeAllListeners = () => {
    initListState.setState({ isBlocked: false });
    const { keydownListenerId, selectionChangeListenerId } = listenerState.state;

    hdrm.listeners.eventListeners.removeById(element, 'keydown', keydownListenerId);
    hdrm.listeners.eventListeners.removeById(
      ownerDocument,
      'selectionchange',
      selectionChangeListenerId
    );
  };

  const initSelectionchangeListener = () =>
    /*
      Since we add this a listener in the same moment as we make some manipulations with DOM
      we should add selectionchange listener with delay.
     */
    setTimeout(() => {
      const selectionChangeListenerId = hdrm.listeners.eventListeners.add(
        ownerDocument,
        'selectionchange',
        removeAllListeners
      );

      listenerState.setState({ selectionChangeListenerId });
    }, SELECTION_LISTENER_DELAY);

  const backspaceListener = (event) => {
    if (event.key !== 'Backspace') return;

    const store = connectedStore.get();
    store.dispatch(actions.undo());

    event.preventDefault();
    event.stopPropagation();

    removeAllListeners();

    initListState.setState({ isBlocked: true });

    initSelectionchangeListener();
  };

  const keydownListenerId = hdrm.listeners.eventListeners.add(
    element,
    'keydown',
    backspaceListener
  );
  listenerState.setState({ keydownListenerId });
  initSelectionchangeListener();
};

export default revertListListener;
